module.exports = __webpack_public_path__ + "img/information.92cd0283.svg";